module.exports = __webpack_public_path__ + "img/success_OLD_0.47f3acc3.gif";